
import React, { useEffect, useState } from 'react';
import { Row, Space, Button, Modal, Col } from 'antd';
import { FormProps } from '../../utility/types';
import { useForm } from '../../utility/useForm';
import { NoValidateForm } from '../../utility/validationRules';
import { ValidationErrorSpan } from '../../styles/global';
import { errorNotify, sucessNotify } from '../../services/toast.notification';
import { NewBranchOffice, sendCable } from '../../api/api';
import FormContainer from '../../components/FormContainer/FormContainer';
import CustomTextArea from '../../components/_common/CustomTextArea';
import { mode } from 'crypto-js';


export const NewBranchOfficeDialog: React.FC<FormProps> = ({ visible, onSubmit, onCancel, payLoad, setShowDialog }) => {

    const { values, errors, handleChange, handleSubmit, setErrors, setValues } = useForm(NoValidateForm) as any
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type];
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    useEffect(() => {
        if (!visible) return;
        setValues({
            officeName: payLoad?.branchOfficeName ?? "",
            officeDesc: payLoad?.branchOfficeDesc ?? "",
        });
    }, [visible]);


    const onSubmitForm = (e: any) => {
        e.preventDefault();

        var model = {
            "mode": payLoad.mode,
            "branchOfficeId": payLoad.branchOfficeId,
            "branchOfficeVUserId": 0,
            "branchOfficeVStateId": 0,
            "stateId": 0,
            "userId": 0,
            "branchName": values.officeName,
            "branchDesc": values.officeDesc
        }

        setIsSubmiting(true)
        NewBranchOffice(model)
            .then((result: any) => {
                sucessNotify("اطلاعات با موفقیت ذخیره شده", undefined, 5000)
                setIsSubmiting(false)
                onCancel();
            })
            .catch((error) => {
                setIsSubmiting(false)
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })


    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
            <>
                <FormContainer title="اطلاعات نمایندگی" onSubmit={onSubmitForm} onCancel={() => setShowDialog(false)} isLoading={isLoading} isSubmiting={isSubmiting} >
                    <Row>
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <CustomTextArea
                                name="officeName"
                                placeholder="نام نمایندگی"
                                value={values.officeName || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="officeName" />
                        </Col>
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <CustomTextArea
                                name="officeDesc"
                                placeholder="توضیحات"
                                value={values.officeDesc || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="officeDesc" />
                        </Col>
                    </Row>

                </FormContainer>
            </>

        </Modal>
    )
}